import { render, staticRenderFns } from "./supervisionReportBasic.vue?vue&type=template&id=27c54987&"
import script from "./supervisionReportBasic.vue?vue&type=script&lang=js&"
export * from "./supervisionReportBasic.vue?vue&type=script&lang=js&"
import style0 from "./supervisionReportBasic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports